import './PhoneAppHeader.css';
import * as React from "react";
import PropTypes from "prop-types";
import icon from "../images/layout/houtenluiken-icon.svg";
import arrow from "../images/layout/arrow-left-solid.svg";
import twoArrow from "../images/layout/angles-left-solid.svg";

PhoneAppHeader.propTypes = {
    title: PropTypes.string.isRequired,
    quitPhoneApp: PropTypes.func.isRequired,
    onPrevious: PropTypes.func,
}

export default function PhoneAppHeader(props) {
    return <>
        <header className="phone-app-header">
            <img className="exit-phone-mode-icon" onPointerUp={e => {
                e.preventDefault();
                props.quitPhoneApp();
            }} src={arrow} alt={"terug"}/>
            <div className="title">Offerte aanvraag</div>
            <img className="icon" src={icon} alt={"icon"}/>
        </header>
        <header className="phone-app-under-header">
            {props.onPrevious && <img className="previous-icon" onPointerUp={e => {
                e.preventDefault();
                props.onPrevious();
            }} src={twoArrow} alt={"terug"}/>}
            <div className="title">{props.title}</div>
        </header>
    </>;
}
